"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicEffect = exports.usePromise = exports.useWarning = exports.useNestedStylesByKey = exports.useCounter = exports.useForceRender = exports.useId = exports.useUncontrolled = exports.useListState = exports.useScript = exports.useDebounce = exports.useInterval = exports.usePartialState = exports.useModal = exports.useBooleanToggle = exports.useToggle = exports.usePrevious = exports.onUpdate = exports.onMount = exports.useReducer = exports.useDebugValue = exports.useLayoutEffect = exports.useContext = exports.useCallback = exports.useMemo = exports.useImperativeHandle = exports.useState = exports.useRef = exports.useEffect = exports.useUnmount = void 0;
/* eslint-disable max-lines */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-restricted-imports */
var react_1 = require("react");
Object.defineProperty(exports, "useEffect", { enumerable: true, get: function () { return react_1.useEffect; } });
Object.defineProperty(exports, "useRef", { enumerable: true, get: function () { return react_1.useRef; } });
Object.defineProperty(exports, "useState", { enumerable: true, get: function () { return react_1.useState; } });
Object.defineProperty(exports, "useImperativeHandle", { enumerable: true, get: function () { return react_1.useImperativeHandle; } });
Object.defineProperty(exports, "useMemo", { enumerable: true, get: function () { return react_1.useMemo; } });
Object.defineProperty(exports, "useCallback", { enumerable: true, get: function () { return react_1.useCallback; } });
Object.defineProperty(exports, "useContext", { enumerable: true, get: function () { return react_1.useContext; } });
Object.defineProperty(exports, "useLayoutEffect", { enumerable: true, get: function () { return react_1.useLayoutEffect; } });
Object.defineProperty(exports, "useDebugValue", { enumerable: true, get: function () { return react_1.useDebugValue; } });
Object.defineProperty(exports, "useReducer", { enumerable: true, get: function () { return react_1.useReducer; } });
var object_1 = require("./object");
var misc_1 = require("./misc");
var StyleProvider_1 = require("../styles/StyleProvider");
var _1 = require(".");
var useUnmount_1 = require("react-use/lib/useUnmount");
Object.defineProperty(exports, "useUnmount", { enumerable: true, get: function () { return __importDefault(useUnmount_1).default; } });
var onMount = function (func) {
    (0, react_1.useEffect)(function () {
        return func();
    }, []);
};
exports.onMount = onMount;
var onUpdate = function (func, listeners) {
    if (listeners === void 0) { listeners = []; }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(function () {
        return func();
    }, listeners);
};
exports.onUpdate = onUpdate;
var usePrevious = function (value) {
    var ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        ref.current = value;
    });
    return ref.current;
};
exports.usePrevious = usePrevious;
function useToggle(options, initial) {
    var _a = __read((0, react_1.useState)(initial), 2), value = _a[0], setValue = _a[1];
    function toggleOrSetValue(newValue) {
        var v = newValue || (value === options[0] ? options[1] : options[0]);
        setValue(v);
    }
    return [value, toggleOrSetValue];
}
exports.useToggle = useToggle;
function useBooleanToggle(initial) {
    var _a = __read((0, react_1.useState)(initial), 2), v = _a[0], setV = _a[1];
    function toggleOrSet(value) {
        if (typeof value === 'boolean') {
            setV(value);
        }
        else {
            setV(function (previous) { return !previous; });
        }
    }
    return [v, toggleOrSet];
}
exports.useBooleanToggle = useBooleanToggle;
function useModal(startsOpen) {
    if (startsOpen === void 0) { startsOpen = false; }
    var _a = __read(useBooleanToggle(startsOpen), 2), visible = _a[0], toggle = _a[1];
    return {
        visible: visible,
        toggle: toggle,
    };
}
exports.useModal = useModal;
function usePartialState(initial) {
    var _a = __read((0, react_1.useState)(initial), 2), state = _a[0], setState = _a[1];
    function setPartial(value) {
        if (typeof value === 'function') {
            setState(function (v) { return (0, object_1.deepMerge)(v, value(v)); });
        }
        else {
            setState((0, object_1.deepMerge)(state, value));
        }
    }
    return [
        state,
        setPartial,
    ];
}
exports.usePartialState = usePartialState;
function useInterval(callback, interval, deps) {
    if (deps === void 0) { deps = []; }
    var intervalRef = (0, react_1.useRef)(null);
    function clear() {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    }
    function start() {
        intervalRef.current = setInterval(callback, interval);
    }
    return {
        clear: clear,
        start: start,
        interval: intervalRef.current,
    };
}
exports.useInterval = useInterval;
function useDebounce(value, debounce) {
    var _a = __read((0, react_1.useState)(value), 2), debouncedValue = _a[0], setDebouncedValue = _a[1];
    var timeoutRef = (0, react_1.useRef)(null);
    var reset = function () {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    };
    (0, react_1.useEffect)(function () {
        timeoutRef.current = setTimeout(function () {
            setDebouncedValue(value);
        }, debounce);
        return reset;
    }, [value]);
    return [debouncedValue, reset];
}
exports.useDebounce = useDebounce;
function useScript(src) {
    var _a = __read((0, react_1.useState)(src ? 'loading' : 'idle'), 2), status = _a[0], setStatus = _a[1];
    (0, react_1.useEffect)(function () {
        if (!src) {
            setStatus('idle');
            return;
        }
        // Fetch existing script element by src
        // It may have been added by another instance of this hook
        var script = document.querySelector("script[src=\"".concat(src, "\"]"));
        if (!script) {
            // Create script
            script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.setAttribute('data-status', 'loading');
            // Add script to document body
            document.body.appendChild(script);
            // Store status in attribute on script
            // This can be read by other instances of this hook
            var setAttributeFromEvent = function (event) {
                script === null || script === void 0 ? void 0 : script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error');
            };
            script.addEventListener('load', setAttributeFromEvent);
            script.addEventListener('error', setAttributeFromEvent);
        }
        else {
            // Grab existing script status from attribute and set to state.
            setStatus(script.getAttribute('data-status'));
        }
        // Script event handler to update status in state
        // Note: Even if the script already exists we still need to add
        // event handlers to update the state for *this* hook instance.
        var setStateFromEvent = function (event) {
            setStatus(event.type === 'load' ? 'ready' : 'error');
        };
        // Add event listeners
        script.addEventListener('load', setStateFromEvent);
        script.addEventListener('error', setStateFromEvent);
        // Remove event listeners on cleanup
        return function () {
            if (script) {
                script.removeEventListener('load', setStateFromEvent);
                script.removeEventListener('error', setStateFromEvent);
            }
        };
    }, [src]);
    return status;
}
exports.useScript = useScript;
function useListState(initialValue) {
    if (initialValue === void 0) { initialValue = []; }
    var _a = __read((0, react_1.useState)(initialValue), 2), state = _a[0], setState = _a[1];
    var append = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return setState(function (current) { return __spreadArray(__spreadArray([], __read(current), false), __read(items), false); });
    };
    var prepend = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return setState(function (current) { return __spreadArray(__spreadArray([], __read(items), false), __read(current), false); });
    };
    var insert = function (index) {
        var items = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            items[_i - 1] = arguments[_i];
        }
        return setState(function (current) { return __spreadArray(__spreadArray(__spreadArray([], __read(current.slice(0, index)), false), __read(items), false), __read(current.slice(index)), false); });
    };
    var apply = function (fn) { return setState(function (current) { return current.map(function (item, index) { return fn(item, index); }); }); };
    var remove = function () {
        var indices = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            indices[_i] = arguments[_i];
        }
        return setState(function (current) { return current.filter(function (_, index) { return !indices.includes(index); }); });
    };
    var pop = function () { return setState(function (current) {
        var cloned = __spreadArray([], __read(current), false);
        cloned.pop();
        return cloned;
    }); };
    var shift = function () { return setState(function (current) {
        var cloned = __spreadArray([], __read(current), false);
        cloned.shift();
        return cloned;
    }); };
    var reorder = function (_a) {
        var from = _a.from, to = _a.to;
        return setState(function (current) {
            var cloned = __spreadArray([], __read(current), false);
            var item = current[from];
            cloned.splice(from, 1);
            cloned.splice(to, 0, item);
            return cloned;
        });
    };
    var setItem = function (index, item) { return setState(function (current) {
        var cloned = __spreadArray([], __read(current), false);
        cloned[index] = item;
        return cloned;
    }); };
    var setItemProp = function (index, prop, value) { return setState(function (current) {
        var _a;
        var cloned = __spreadArray([], __read(current), false);
        cloned[index] = __assign(__assign({}, cloned[index]), (_a = {}, _a[prop] = value, _a));
        return cloned;
    }); };
    var applyWhere = function (condition, fn) { return setState(function (current) { return current.map(function (item, index) { return (condition(item, index) ? fn(item, index) : item); }); }); };
    return [
        state,
        {
            setState: setState,
            append: append,
            prepend: prepend,
            insert: insert,
            pop: pop,
            shift: shift,
            apply: apply,
            applyWhere: applyWhere,
            remove: remove,
            reorder: reorder,
            setItem: setItem,
            setItemProp: setItemProp,
        },
    ];
}
exports.useListState = useListState;
function useUncontrolled(_a) {
    var value = _a.value, defaultValue = _a.defaultValue, finalValue = _a.finalValue, rule = _a.rule, onChange = _a.onChange, onValueUpdate = _a.onValueUpdate;
    // determine, whether new props indicate controlled state
    var shouldBeControlled = rule(value);
    // initialize state
    var modeRef = (0, react_1.useRef)('initial');
    var initialValue = rule(defaultValue) ? defaultValue : finalValue;
    var _b = __read((0, react_1.useState)(initialValue), 2), uncontrolledValue = _b[0], setUncontrolledValue = _b[1];
    // compute effective value
    var effectiveValue = shouldBeControlled ? value : uncontrolledValue;
    if (!shouldBeControlled && modeRef.current === 'controlled') {
        // We are transitioning from controlled to uncontrolled
        // this transition is special as it happens when clearing out
        // the input using "invalid" value (typically null or undefined).
        //
        // Since the value is invalid, doing nothing would mean just
        // transitioning to uncontrolled state and using whatever value
        // it currently holds which is likely not the behavior
        // user expects, so lets change the state to finalValue.
        //
        // The value will be propagated to internal state by useEffect below.
        effectiveValue = finalValue;
    }
    modeRef.current = shouldBeControlled ? 'controlled' : 'uncontrolled';
    var mode = modeRef.current;
    var handleChange = function (nextValue) {
        typeof onChange === 'function' && onChange(nextValue);
        // Controlled input only triggers onChange event and expects
        // the controller to propagate new value back.
        if (mode === 'uncontrolled') {
            setUncontrolledValue(nextValue);
        }
    };
    (0, react_1.useEffect)(function () {
        if (mode === 'uncontrolled') {
            setUncontrolledValue(effectiveValue);
        }
        typeof onValueUpdate === 'function' && onValueUpdate(effectiveValue);
    }, [mode, effectiveValue]);
    return [effectiveValue, handleChange, modeRef.current];
}
exports.useUncontrolled = useUncontrolled;
function useId(prefix) {
    var _id = (0, react_1.useId)();
    return prefix ? "".concat(prefix).concat(_id) : _id;
}
exports.useId = useId;
function useForceRender() {
    var _a = __read((0, react_1.useReducer)(function (x) { return x + 1; }, 0), 2), _ = _a[0], forceRender = _a[1];
    return forceRender;
}
exports.useForceRender = useForceRender;
function useCounter() {
    return (0, react_1.useReducer)(function (x) { return x + 1; }, 0);
}
exports.useCounter = useCounter;
function useNestedStylesByKey(match, variantStyles) {
    return (0, react_1.useMemo)(function () {
        return (0, misc_1.getNestedStylesByKey)(match, variantStyles);
    }, []);
}
exports.useNestedStylesByKey = useNestedStylesByKey;
function useWarning(condition) {
    var logArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        logArgs[_i - 1] = arguments[_i];
    }
    var logged = (0, react_1.useRef)(false);
    var logger = (0, StyleProvider_1.useCodeleapContext)().logger;
    if (!logged.current && condition) {
        logged.current = true;
        logger === null || logger === void 0 ? void 0 : logger.warn.apply(logger, __spreadArray([], __read(logArgs), false));
    }
}
exports.useWarning = useWarning;
var usePromise = function (options) {
    var rejectRef = (0, react_1.useRef)();
    var resolveRef = (0, react_1.useRef)();
    var timeoutRef = (0, react_1.useRef)(null);
    var reject = function (err) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, ((_a = rejectRef.current) === null || _a === void 0 ? void 0 : _a.call(rejectRef, err))];
                case 1:
                    _c.sent();
                    (_b = options === null || options === void 0 ? void 0 : options.onReject) === null || _b === void 0 ? void 0 : _b.call(options, err);
                    if (timeoutRef.current)
                        clearTimeout(timeoutRef.current);
                    rejectRef.current = null;
                    return [2 /*return*/];
            }
        });
    }); };
    var resolve = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, ((_a = resolveRef.current) === null || _a === void 0 ? void 0 : _a.call(resolveRef, value))];
                case 1:
                    _c.sent();
                    (_b = options === null || options === void 0 ? void 0 : options.onResolve) === null || _b === void 0 ? void 0 : _b.call(options, value);
                    if (timeoutRef.current)
                        clearTimeout(timeoutRef.current);
                    resolveRef.current = null;
                    return [2 /*return*/];
            }
        });
    }); };
    var _await = function () {
        return new Promise(function (resolve, reject) {
            rejectRef.current = reject;
            resolveRef.current = resolve;
            if (_1.TypeGuards.isNumber(options === null || options === void 0 ? void 0 : options.timeout) && (options === null || options === void 0 ? void 0 : options.timeout) > 0) {
                timeoutRef.current = setTimeout(function () {
                    reject(new Error("usePromise: ".concat((options === null || options === void 0 ? void 0 : options.debugName) || '', " timed out after ").concat(options === null || options === void 0 ? void 0 : options.timeout, "ms")));
                }, options === null || options === void 0 ? void 0 : options.timeout);
            }
        });
    };
    return {
        _await: _await,
        resolve: resolve,
        reject: reject,
    };
};
exports.usePromise = usePromise;
// useLayoutEffect will show warning if used during ssr, e.g. with Next.js
// useIsomorphicEffect removes it by replacing useLayoutEffect with useEffect during ssr
exports.useIsomorphicEffect = typeof document !== 'undefined' ? react_1.useLayoutEffect : react_1.useEffect;
